<template>
    <Head title="Connexion"/>
  <div class="flex items-center justify-center min-h-screen p-6 light login-bg">
      <flash-messages />
    <div class="w-full max-w-md">
        <Link :href="route('home')"><logo class="block w-48 mx-auto fill-white rounded-xl" /></Link>
      <form class="mt-8 overflow-hidden bg-white border border-gray-100 rounded-lg shadow-xl auth " @submit.prevent="login">
        <div class="px-8 py-5">
          <h2 class="text-xl font-bold text-center">{{ __('Connexion') }}</h2>
          <div class="w-24 mx-auto mt-2 border-b" />
          <text-input v-model="form.email" :error="form.errors.email" class="mt-10" label="Email" type="email" autofocus autocapitalize="off" />
          <text-input v-model="form.password" :error="form.errors.password" class="mt-6" label="Password" type="password" />
          <label class="flex items-center mt-6 select-none" for="remember">
            <input id="remember" v-model="form.remember" class="mr-1" type="checkbox" />
            <span class="text-sm">Se souvenir de moi</span>
          </label>
            <div class="flex items-center justify-center pt-4">
                <vue-recaptcha v-if="site_key" :sitekey="site_key"
                               size="normal"
                               theme="light"
                               @verify="recaptchaVerified"
                               @expire="recaptchaExpired"
                               @fail="recaptchaFailed"
                               @error="recaptchaError"
                               ref="vueRecaptcha">
                </vue-recaptcha>
            </div>
            <loading-button :disabled="disable_login_button && site_key" :loading="form.processing" class="items-center justify-center w-full mt-4 ml-auto btn-indigo" type="submit" :class="{'opacity-50 cursor-not-allowed': disable_login_button && site_key}">{{ __('Se connecter') }}</loading-button>
            <div class="flex justify-center mt-5"><Link class="ml-2 " :href="route('password.reset')">Mot de passe oublié?</Link></div>
        </div>
          <div class="flex flex-col items-center gap-1 pb-2 bg-white border-t border-gray-100 login-as" v-if="is_demo">
              <table style="width:100%" class="mb-1">
                  <thead>
                    <tr>
                      <th>Role</th>
                      <th>Email</th>
                      <th>Password</th>
                      <th>Action</th>
                  </tr>
                  </thead>
                  <tbody>
                    
                    <tr>
                        <td>Admin</td>
                        <td>admin@systeme.bj</td>
                        <td>password</td>
                        <td class="action" @click="autofillLogin($event, 'admin')">Copy</td>
                    </tr>
                    <tr>
                        <td>Manager</td>
                        <td>robert.slaughter@mail.com</td>
                        <td>w3bd.com</td>
                        <td class="action" @click="autofillLogin($event, 'manager')">Copy</td>
                    </tr>
                    <tr>
                        <td>Customer</td>
                        <td>mmarks@example.com</td>
                        <td>w3bd.com</td>
                        <td class="action" @click="autofillLogin($event, 'customer')">Copy</td>
                    </tr>
                  </tbody>
              </table>
              <h2 class="mb-1 text-sm font-bold">Quick Login Without Captcha As: </h2>
              <div class="flex flex-col gap-3 action sm:flex-row">
                  <button class=" btn-indigo" @click="autofillLogin($event, 'admin', true)">Admin</button>
                  <button class=" btn-indigo" @click="autofillLogin($event,'manager', true)">Manager</button>
                  <button class=" btn-indigo" @click="autofillLogin($event,'customer', true)">Customer</button>
              </div>
          </div>

      </form>
    </div>
  </div>
</template>

<script>
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import { Head, Link } from '@inertiajs/vue3'
import FlashMessages from '@/Shared/FlashMessages'
import vueRecaptcha from 'vue3-recaptcha2';

export default {
  metaInfo: { title: 'Login' },
  components: {
      FlashMessages,
    LoadingButton,
    Logo,
    TextInput,
      Head,
      Link,
      vueRecaptcha,
  },
    props: {
        is_demo: Number,
        site_key: String
    },
  data() {
    return {
        loadingTimeout: 30000,
        disable_login_button: true,
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: false,
      }),
    }
  },
  methods: {
      recaptchaVerified(response) {
          this.disable_login_button = false
          console.log(response)
      },
      recaptchaExpired() {
          this.$refs.vueRecaptcha.reset();
      },
      recaptchaFailed() {
      },
      recaptchaError(reason) {
          console.log(reason)
      },
      login() {
          this.form.post(this.route('login.store'))
      },
      autofillLogin(e, role, login){
          e.preventDefault()
          const roleEmails = { 'admin': 'john.due.helo@mail.com', 'manager': 'robert.slaughter@mail.com', 'customer' : 'mmarks@example.com'}
          this.form.email = roleEmails[role]
          this.form.password = 'w3bd.com'
          if(login){
              this.login();
          }
      }
  }
}
</script>
